/**
 * GlobalLoginContextChoiceHost — renders the role-aware post-login choice
 * modal in response to global `requestLoginContextChoice` events. Lives at
 * the App root so the modal survives auth-flow component unmounts (e.g.
 * LiteAuthSheet which is gated by `{!user && ...}`).
 */
import LoginContextChoiceModal from "@/components/LoginContextChoiceModal";
import { useLoginContextChoiceRequest } from "@/stores/loginContextChoiceStore";

export default function GlobalLoginContextChoiceHost() {
  const { req, clear } = useLoginContextChoiceRequest();
  return (
    <LoginContextChoiceModal
      open={req !== null}
      userId={req?.userId ?? null}
      role={req?.role ?? null}
      onChosen={clear}
    />
  );
}
